import styled from 'styled-components';

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid var(--primary-color20);
  margin-top: 1.5rem;
  margin-bottom: 2.5rem;
`;

export const VerticalDivider = styled.span`
  display: inline-block;
  height: 100%;
  width: 1px;
  border: 0;
  background: var(--primary-color20);
`;
